var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "left" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("../../static/mobile/ic_120.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "info" }, [
          _c("div", { staticClass: "payraja" }, [_vm._v("PayRaja")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.$t("Earn Money as a UPI Agent")))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "download", on: { click: _vm.download_apk } }, [
        _vm._v(_vm._s(_vm.$t("Download APK")))
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "banner",
      class: _vm.locale == "hi" ? "hi-bg" : "en-bg",
      on: { click: _vm.download_apk }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "content-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("Become a UPI Payment Agent & Start Earning!")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data-box" },
        [
          _c("div", { staticClass: "data-title data-box-item" }, [
            _c("div", { staticClass: "amount" }, [
              _vm._v(_vm._s(_vm.$t("Order Amount")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bonus-earn" }, [
              _c("div", { staticClass: "bonus" }, [
                _c("img", {
                  staticClass: "ic_arow",
                  attrs: {
                    src: require("../../static/mobile/ic_arow.png"),
                    alt: ""
                  }
                }),
                _vm._v(
                  "\n            " + _vm._s(_vm.$t("Bonus")) + "\n          "
                )
              ]),
              _vm._v(
                "\n          " + _vm._s(_vm.$t("You Can Earn")) + "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.datas, function(item, i) {
            return _c(
              "div",
              { key: i, staticClass: "data-item data-box-item" },
              [
                _c("div", { staticClass: "amount" }, [
                  _vm._v(_vm._s(item.amount))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bonus-earn" }, [
                  _c("img", {
                    staticClass: "ic_coin",
                    attrs: {
                      src: require("../../static/mobile/ic_coin.png"),
                      alt: ""
                    }
                  }),
                  _vm._v("\n          " + _vm._s(item.bonus) + "\n        ")
                ])
              ]
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "fixed-bottom" }, [
      _c("div", { staticClass: "btn", on: { click: _vm.download_apk } }, [
        _c("img", {
          staticClass: "ic_download",
          attrs: {
            src: require("../../static/mobile/ic_download.png"),
            alt: ""
          }
        }),
        _vm._v(
          "\n      " + _vm._s(_vm.$t("Download to Earn Money Now")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "five-icon",
        attrs: { src: require("../../static/mobile/five_icon.png"), alt: "" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df03802e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df03802e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Google.vue
// module id = null
// module chunks = 